import { MapTo } from '@adobe/aem-react-editable-components';
import ImageGallery, { ImageGalleryEditConfig } from './ImageGallery';

export default MapTo('cob-corp-acquisition/components/creditonebank/image-gallery')(ImageGallery, ImageGalleryEditConfig);